import { HiShieldCheck } from "react-icons/hi";
import { MdCancel, MdAnalytics } from "react-icons/md";
const data = [
  {
    icon: <HiShieldCheck/>,
    heading: "Best interest rates",
    detail:
      "We provide the best interest rates",
  },
  {
    icon: <MdCancel />,
    heading: "Prevent unstable prices",
    detail:
      "The price at which we sell our products is a stable price",
  },
  {
    icon: <MdAnalytics />,
    heading: "Best price on the market",
    detail:
      "We sell at a very low price",
  },
];
export default data;